<template>
  <div class="navbar navbar-default navbar-fixed-top" role="navigation">
    <div class="navbar-header">
      <button type="button" id="navBtn" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
        <span class="sr-only">Toggle navigation</span>
        <em class="fa fa-bars"></em> Menu
      </button>
      <a class="navbar-brand" href="https://www.csub.edu" title="CSUB Home Page" target="_blank">
        <img src="../assets/images/CSUB_Logo.png" alt="CSUB Logo" /></a>
    </div>
    <div class="collapse navbar-collapse">
      <ul class="nav navbar-nav">
        <li class="dropdown">
          <a href="" class="dropdown-toggle" data-toggle="dropdown">More Access<em class="caret"></em></a>
          <ul class="dropdown-menu">
            <div v-for="(link, idx) in moreAccess" :key="idx">
              <li><a target="_blank" :title="link.name" :href="link.loc" v-html="link.name"></a></li>
              <li class="divider"></li>
            </div>
          </ul>
        </li>
        <li>
          <a href="https://myhr.csub.edu/">myHR</a>
        </li>
        <li class="dropdown">
          <a href="" class="dropdown-toggle" data-toggle="dropdown">myCSUB Guides<em class="caret"></em></a>
          <ul class="dropdown-menu">
            <div v-for="(link, idx) in myGuides" :key="idx">
              <li><a :href="link.loc" target="_blank" v-html="link.name"></a></li>
              <li class="divider"></li>
            </div>
          </ul>
        </li>
        <li class="dropdown">
          <a href="" class="dropdown-toggle" data-toggle="dropdown">Need Help?<em class="caret"></em></a>
          <ul class="dropdown-menu">
            <div v-for="(link, idx) in needHelp" :key="idx">
              <li><a :href="link.loc" target="_blank" v-html="link.name"></a></li>
              <li class="divider"></li>
            </div>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  data () {
    return {
      moreAccess: [
        {
          name: 'O365 Email &amp; Calendar',
          loc: 'https://o365.csub.edu'
        },
        {
          name: 'Canvas',
          loc: 'https://canvas.csub.edu'
        },
        {
          name: 'Faculty &amp; Staff',
          loc: 'https://www.csub.edu/faculty-and-staff'
        }
      ],
      myGuides: [
        {
          name: 'Student Guides',
          loc: 'https://www.csub.edu/training/student/'
        },
        {
          name: 'Faculty Guides',
          loc: 'https://www.csub.edu/training/faculty/'
        },
        {
          name: 'Staff Guides',
          loc: 'https://www.csub.edu/training/student/'
        }
      ],
      needHelp: [
        {
          name: 'Find my Net ID',
          loc: 'https://www.csub.edu/myid'
        },
        {
          name: 'Manage Password',
          loc: 'https://www.csub.edu/myid'
        },
        {
          name: 'Account Disabled?',
          loc: 'https://www.csub.edu/myid/'
        },
        {
          name: 'New to the Campus?',
          loc: 'https://csub.service-now.com/sp?id=sc_category&sys_id=8a2ff3cd6fac2100ad775ddd5d3ee4d8'
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .navbar-default {
    background: #24C6DC; /* fallback for old browsers */
    background: -webkit-linear-gradient(to left, rgba(0, 53, 148, 1), rgba(0, 26, 112, 1) ); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to left,  rgba(0, 53, 148, 1), rgba(0, 26, 112, 1) ); /*W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    font-family: 'Oswald', sans-serif;
    border-bottom: 3px solid #ffd200;
  }

  .navbar-default .navbar-nav > li > a {
    font-family: 'Oswald', sans-serif;
    font-size: 20px;
    /* font-weight: bold; */
    color: white !important;
    padding-top: 15px;
    margin-top: 15px;
  }

  .navbar-default .navbar-nav > li > a:hover {
    background: rgba(255, 199, 44, 1) !important;
    font-size: 20px;
    color: #000 !important;
  }

  .navbar-default .navbar-header > a {
    font-family: 'Alegreya', serif;
    color: rgba(255, 199, 44, 1);
    font-size: 28px;
    margin-top: 0px !important;
    padding-top: 10px !important;
    height: 90px;
  }

  .navbar-default .navbar-header > a:hover, .navbar-default .navbar-header .active > a:hover {
    font-family: 'Alegreya', serif;
    color: rgba(255, 199, 44, 1);
    font-size: 28px;
  }

  .navbar-default .navbar-nav > .open > a, .navbar-default .navbar-nav > .open > a:focus, .navbar-default .navbar-nav > .open > a:hover {
    background-color: rgba(255, 199, 44, 1) !important;
  }

  .dropdown-menu {
    background: white !important;
  }

  .dropdown-menu > li:hover {
    background: rgba(255, 210, 0, 0.25) !important;
  }

  .dropdown-menu > div > li > a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap;
  }

  .dropdown-menu > div > li > a {
    color: #0b6dac !important;
    background: white !important;
  }

  .dropdown-menu > li > a:hover {
    background-color: transparent !important;
  }

  #navBtn {
    background-color: rgba(251, 251, 251, 0.95);
    color: black;
  }
</style>
